import { Field, Input, InputProps } from '@fluentui/react-components';
import { FieldValues, UseControllerProps } from 'react-hook-form';
import InputWrapper from '../layout/InputWrapper';
import { useFormField } from './useFormField';

type TextInputProps<T extends FieldValues> = UseControllerProps<T> &
    InputProps & {
        label?: string;
        className?: string;
        /** Classes for the outer wrapper (the flex item when the field sits in a row). */
        wrapperClassName?: string;
        minWidth?: number;
    };

const TextInput = <T extends FieldValues>(props: TextInputProps<T>) => {
    const { name, control, rules, defaultValue, label, className, wrapperClassName, minWidth, ...rest } = props;

    const { field, errorMessage, isRequired } = useFormField({
        name,
        control,
        rules,
        defaultValue,
    });

    return (
        <InputWrapper className={wrapperClassName}>
            <Field validationMessage={errorMessage} className={className} label={label} required={isRequired}>
                <Input {...field} {...rest} />
            </Field>
        </InputWrapper>
    );
};

export default TextInput;
